import React from 'react';
import LandingPageBg from '../../images/SA.jpg'; // Adjust the path as necessary

const About = () => {
  return (
    <div className="bg-gray-100 min-h-screen">
      {/* Hero Section with Image */}
      <div
        className="relative bg-blue-600 text-white py-20 px-4 text-center"
        style={{
          backgroundImage: `url(${LandingPageBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '50vh', // Adjust height as needed
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50"></div> {/* Overlay */}
        <div className="relative z-10">
          <h1 className="text-6xl font-bold mb-4">Bookurspot</h1>
          <p className="text-2xl">
            Our Spot, Your Way – Seamless Booking, Endless Possibilities!
          </p>
          <h3 className="text-lg my-8">Discover perfect venues and activities</h3>
        </div>
      </div>

      {/* Content Section */}
      <div className="container mx-auto py-10 px-4 space-y-12">
        {/* What We Do */}
        <section>
          <h2 className="text-2xl font-bold text-gray-800 mb-4">What We Do</h2>
          <p className="text-gray-600 leading-7">
            We are Bookurspot, a platform that connects users to the perfect venues and activities. Our mission is to simplify bookings for users while empowering venue owners, focusing on diversity, accessibility, innovation, and 24/7 support. Catering to a wide range of ages, our platform is designed for everyone of any age group, ensuring something for every generation.
          </p>
        </section>

       
        {/* Our Vision */}
        <section>
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Our Vision</h2>
          <p className="text-gray-600 leading-7">
            We aim to become the go-to platform for booking sports venues and event spaces. By bringing technology, transparency,
            and trust to the booking process, we empower users to focus on what matters most: enjoying their events.
          </p>
        </section>

        {/* Our Team */}
        <section>
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Our Team</h2>
          <p className="text-gray-600 leading-7">
            Our team is a blend of passionate professionals with expertise in technology, customer service, and marketing team.
            Together, we strive to provide the best experience for our users.
          </p>
        </section>
         {/* Pricing Plan */}
        <section className="bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Pricing Plan</h2>
          <p className="text-gray-600 leading-7 mb-4">
            At Bookurspot, we believe in building strong partnerships. That’s why we offer new partners a <strong>1-month free trial period</strong> to experience the benefits of our platform.
          </p>
          <p className="text-gray-600 leading-7">
            After the trial period, we charge a <strong>12% commission</strong> on the booking amount, ensuring a fair and transparent pricing model. Our goal is to help you maximize your bookings and revenue while providing exceptional service to your customers.
          </p>
        </section>

        {/* Contact Section */}
        <section className="bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Contact Us</h2>
          <p className="text-gray-600 leading-7 mb-4">
            Have questions or need support? Feel free to reach out to us!
          </p>
          <ul className="space-y-2">
            <li>
              <strong>Email:</strong> support@bookurspot.com
            </li>
            <li>
              <strong>Phone:</strong> +91 98765 43210
            </li>
            <li>
              <strong>Address:</strong> 123, Tech Park, Chennai, Tamil Nadu, India
            </li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default About;
